import InsertDriveFile from 'material-ui/svg-icons/editor/insert-drive-file';
import React from 'react';

export const materialTypeIcons = {
  'whole school': <InsertDriveFile className="lesson-card-type-icon material" />,
  'poster': <InsertDriveFile className="lesson-card-type-icon material" />,
  'coloring sheet': <InsertDriveFile className="lesson-card-type-icon material" />,
  'tickets': <InsertDriveFile className="lesson-card-type-icon material" />,
  'behavior plan': <InsertDriveFile className="lesson-card-type-icon material" />,
  'pt committee': <InsertDriveFile className="lesson-card-type-icon material" />,
  'student team': <InsertDriveFile className="lesson-card-type-icon material" />,
  'handout/worksheet': <InsertDriveFile className="lesson-card-type-icon material" />,
  'other': <InsertDriveFile className="lesson-card-type-icon material" />
};



// WEBPACK FOOTER //
// ./app/features/shared/constants/materialTypeIcons.js